export default __webpack_public_path__ + "static/media/BUY.ad651a25.png";